import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import ErrorPage from "@/presentation/components/error-page/ErrorPage.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Error',
    setup(__props) {
        const SUPPORTED_CODES = ["403", "500", "502", "503", "504"];
        const I18N_SLUG = {
            "403": "forbidden",
            "500": "serverError",
            "502": "badGateway",
            "503": "serviceUnavailable",
            "504": "gatewayTimeout",
        };
        const route = useRoute();
        const resolved = computed(() => {
            const raw = Array.isArray(route.params.code) ? route.params.code[0] : route.params.code;
            const code = SUPPORTED_CODES.includes(raw ?? "")
                ? raw
                : "500";
            const slug = I18N_SLUG[code];
            return {
                code,
                titleKey: `errorPage.${slug}.title`,
                descriptionKey: `errorPage.${slug}.description`,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ErrorPage, {
                code: resolved.value.code,
                "title-key": resolved.value.titleKey,
                "description-key": resolved.value.descriptionKey
            }, null, 8 /* PROPS */, ["code", "title-key", "description-key"]));
        };
    }
});
